import styles from './SobreMi.module.css'

export function SobreMi() {
  return (
    <section id="sobre-mi" className="section section--soft">
      <div className={`container ${styles.inner}`}>
        <div className={`${styles.media} reveal`}>
          <img
            src="/images/emilia-oficina.png"
            alt="Emilia Hidalgo"
            width={1712}
            height={960}
            loading="lazy"
          />
        </div>

        <div className={`${styles.copy} reveal`}>
          <p className="eyebrow">Sobre mí</p>
          <blockquote className={styles.quote}>
            “Creo profundamente en la capacidad de las personas para crecer. Pero también sé que
            querer cambiar no siempre es suficiente.”
          </blockquote>
          <p className={styles.text}>
            Mi trabajo nace del interés por convertir el conocimiento y la experiencia en
            herramientas útiles para otros. He acompañado a personas y organizaciones en la gestión
            de equipos, conflictos, coordinación y los problemas reales del mundo del trabajo.
          </p>
          <p className={styles.text}>
            Esa trayectoria práctica es hoy una de mis mayores fortalezas: entiendo lo que ocurre
            dentro de los equipos y sé cómo transformar esa comprensión en experiencias que dejan
            algo después de terminar. Poco a poco, esta plataforma irá incorporando mi formación,
            certificaciones y experiencia como relatora.
          </p>
          <a href="#contacto" className="btn btn--outline btn--lg">
            Conoce mi historia
          </a>
        </div>
      </div>
    </section>
  )
}
